import { Injector } from '@angular/core';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
export class ServiceLocator {
  static injector: Injector;
}
